import { queryOptions } from '@tanstack/react-query';
import { sessionApi } from './session-api';

export const sessionKeys = {
  all: ['session'] as const,
  me: () => [...sessionKeys.all, 'me'] as const,
};

export const sessionQueries = {
  me: () =>
    queryOptions({
      queryKey: sessionKeys.me(),
      queryFn: () => sessionApi.me(),
      // The current user rarely changes within a session — cache generously and
      // don't retry hard (a 401 already redirects to login via the http client).
      staleTime: 5 * 60_000,
      retry: false,
    }),
};
